import { render } from "./DefaultConfirmRedeem.vue?vue&type=template&id=727ac5da"
import script from "./DefaultConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./DefaultConfirmRedeem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__